export let DatePickerOptions = {
    shortcuts: [{
    text: '最近一周',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近一个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      picker.$emit('pick', [start, end]);
    }
  }, {
    text: '最近三个月',
    onClick(picker) {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
      picker.$emit('pick', [start, end]);
    }
  }]
}

function getDate (dateStr) {
  const temp = dateStr.split("-");
  if (temp[1] === '01') {
    temp[0] = parseInt(temp[0],10) - 1;
    temp[1] = '12';
  } else {
    temp[1] = parseInt(temp[1],10) - 1;
  }
  return new Date(temp[0], temp[1], temp[2]);
}

export function getDiffDate (startTime, endTime) {
  if(typeof startTime === 'string'){
    startTime = getDate(startTime);
    endTime = getDate(endTime);
  }else{
    startTime = new Date(startTime.getTime())
    endTime = new Date(endTime.getTime())
  }
  const dateArr = [];
  while ((endTime.getTime() - startTime.getTime()) >= 0) {
    let year = startTime.getFullYear();
    let month = (startTime.getMonth()+1).toString().length === 1 ? "0" + (parseInt(startTime.getMonth().toString(),10) + 1) : (startTime.getMonth() + 1);
    let day = startTime.getDate().toString().length === 1 ? "0" + startTime.getDate() : startTime.getDate();
    dateArr.push(year + "-" + month + "-" + day);
    startTime.setDate(startTime.getDate() + 1);
  }
  return dateArr;
}

export function timestampToDate(timestamp) {
  let date = new Date(timestamp * 1000);
  let year = date.getFullYear();
  let month = date.getMonth() + 1; // 月份从0开始，需要加1
  let day = date.getDate();
  let hours = date.getHours();
  if(hours < 10){
    hours = "0" +hours;
  }
  let minutes = date.getMinutes();
  if(minutes < 10){
    minutes = "0" +minutes;
  }
  let seconds = date.getSeconds();
  if(seconds < 10){
    seconds = "0" +seconds;
  }
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
}

export function CurDate() {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1; // 月份从0开始，需要加1
  let day = date.getDate();
  return `${year}-${month}-${day}`;
}
